import type { JssContext } from '@/types';
import { inject } from 'vue';

/**
 * Haalt sitecore context op uit app data d.m.v. inject
 * Nodig om o.a. huidige sitecore taal of propositie uit te lezen
 */
const useScContext = () => {
    const jss = (inject as (key: 'jss') => JssContext)('jss');

    return jss?.sitecoreContext() ?? {};
};

export default useScContext;
